import types from "cms/enums/contentsTypes.enum";
export var templateSettings = {
    label: "template settings",
    type: types.TEMPLATE_SETTINGS,
    value: ""
};
